class PartsHelper {
    constructor() {
    }

    addRequestToState(el) {
        // console.log("loaded");
        const form = document.getElementById('single-part-add-to-request');
        form.addEventListener("submit", (e) => {
            e.preventDefault();
            let state = JSON.parse(window.localStorage.getItem("tooling-catalog-state"));
            let quantity = parseInt(e.target[0].value);;

            let data = e.target.dataset;
            let requestObj = {
                engine_applicability: data.partEngineApplicability,
                engine_oem: data.partEngineOem,
                id: parseInt(data.partId),
                link: data.partLink,
                nomenclature: data.partNomenclature,
                qty: quantity,
                root_part_numbers: data.partRootPartNumbers
            };
            // console.log(requestObj);
            if (state) {
                if (state.requests.some(item => item.id === requestObj.id)) {
                    state.requests.map(item => {
                        if (item.id === requestObj.id) {
                            item.qty = quantity;
                        }
                    });
                } else {
                    state.requests.push(requestObj);

                }
            } else {
                state = {
                    paged: 1,
                    order: "",
                    orderby: "",
                    searchTerm: "",
                    selectedFilters: {},
                    filterOptions: {},
                    requests: [requestObj],
                    loaderMessage: "Loading Catalog",
                    showLoader: true,
                    isSubmitting: false,
                    formDrawerOpen: false
                };
            }
            // console.log(state);
            window.localStorage.setItem('tooling-catalog-state', JSON.stringify(state));
            window.location.href = 'https://www.rhinestahl.com/cts/catalog/search';
        });
    }

}


window.app.add('parts', new PartsHelper());